import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type { IPageInfo } from "@/interface/common.interface";

export interface ICreateWfhPayload {
  checkInDate?: string;
  id?: string;
  checkOutDate?: string;
  user?: {
    name?: string;
    id?: string;
    phone?: string;
    email?: string;
  };
  duration?: "FULL_DAY" | "FIRST_HALF" | "SECOND_HALF";
  numberOfDays?: number;
  reason?: string;
  status?: string;
}

export interface IGetWfhListResponse {
  data: {
    wfh: ICreateWfhPayload[];
    pageInfo: IPageInfo;
  };
  message: string;
  status: boolean;
}

export interface IUpdateWfhStatusPayload {
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  remarks?: string;
}

export const WfhService = {
  createWfh: async (payload: ICreateWfhPayload): Promise<any> => {
    const API = `${API_ENDPOINT.wfh}`;
    return callApi(API, { method: "POST", data: payload });
  },

  getWfhList: async (params?: string): Promise<IGetWfhListResponse> => {
    const API = `${API_ENDPOINT.wfh}${params ? `?${params}` : ""}`;
    return callApi<IGetWfhListResponse>(API, { method: "GET" });
  },
  getWfhById: async (id: string): Promise<any> => {
    const API = `${API_ENDPOINT.wfh}/${id}`;
    return callApi(API, { method: "GET" });
  },

  cancelWfh: async (id: string): Promise<any> => {
    const API = `${API_ENDPOINT.wfh}/${id}`;
    return callApi(API, { method: "DELETE" });
  },

  updateWfhStatus: async (
    id: string,
    payload: IUpdateWfhStatusPayload,
  ): Promise<any> => {
    const API = `${API_ENDPOINT.wfh}/${id}/status`;
    return callApi(API, { method: "PUT", data: payload });
  },
};
